var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TimeLine',{ref:"Timeline",attrs:{"timeSegments":_vm.subData}})
}
var staticRenderFns = []

export { render, staticRenderFns }